export default function(phone: string): string {
    if (!phone) {
        return '';
    }

    return phone.replace(' ', '').replace('.', '').replace(/(\d{2,3})(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5 $6');
}